/** The representation of a U.S. county. */
export default interface County {
  /** The parent state of the county. */
  state: string;

  /** The social security identifier for the county. */
  countySSA: string;

  /** The FIPS identifier for the county. */
  countyFIPS: string;

  /** The human friendly name of the county. */
  name: string;

  area: number;
  minLatitude: number;
  minLongitude: number;
  maxLatitude: number;
  maxLongitude: number;
  centroidLatitude: number;
  centroidLongitude: number;
  labelLatitude: number;
  labelLongitude: number;
  zipCount: number;

  /** The medicare classification of the county. */
  medicareCountyClass: MedicareCountyClass;

  usedByCMS: boolean;

  geoJSON: string;
}

interface CountyLite {
  state: string;
  countySSA: string;
  name: string;
}

interface GetNearbyCounties {
  /** Counties to search from. */
  CountySSAs: string[];
  /** Distance to search from source counties in miles */
  Distance: number;
  /** Whether or not to include the source counties */
  IncludeSourceCounties: boolean;
  /** Whether or not to limit to the states of the source counties */
  LimitToCurrentStates: boolean;
}

interface GetNearbyCountiesWithinRange {
  /** Counties to search from. */
  countySSAs: string[];
}

interface CountyWithinRanges extends County {
  /** Counties to search from within ranges. */
  range: number;
}

/** The population based classification of a county. */
enum MedicareCountyClass {
  Unknown = "Unknown",
  LargeMetro = "LargeMetro",
  Metro = "Metro",
  Micro = "Micro",
  Rural = "Rural",
  CEAC = "CEAC", // Counties with Extreme Access Considerations
}

export {
  CountyLite,
  CountyWithinRanges,
  GetNearbyCounties,
  GetNearbyCountiesWithinRange,
  MedicareCountyClass,
};
